<template>
  <view class="mask" :class="{ show: visible, hide: !visible }" @touchmove.stop.prevent="() => {}">
    <view class="inner-area" :class="{ show: visible2, hide: !visible2 }">
      <view class="content-wrapper">
        <slot></slot>
      </view>
      <view
        class="tripwise_outline icon-pop_close_outline a-w-90 a-h-90 a-fs-90 a-c-#f a-m-20-auto-0-auto"
        @click="handleCloseMask"
      ></view>
    </view>
  </view>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible2: false,
      top: '100%',
    };
  },
  watch: {
    visible: {
      handler: function (val) {
        setTimeout(() => {
          this.visible2 = val;
        });
      },
      immediate: true,
    },
  },
  mounted() {
    // this.top = '50%';
  },
  methods: {
    handleCloseMask() {
      this.$emit('closeMask');
    },
  },
};
</script>

<style lang="less" scoped scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  opacity: 0;
  transition: all 0.5s;
  &.show {
    opacity: 1;
    display: block;
  }
  &.hide {
    opacity: 0;
    display: none;
  }
  .inner-area {
    position: absolute;
    bottom: 20rpx;
    left: 20rpx;
    right: 20rpx;
    transition: all 0.3s;
    max-height: calc(100% - 40rpx);
    &.show {
      opacity: 1;
    }
    &.hide {
      opacity: 0;
    }
  }
}
.content-wrapper {
  width: 100%;
  height: calc(100% - 110rpx);
  overflow-y: auto;
  background: #ededed;
  border-radius: 20rpx;
}
</style>
